import { apiFetchJson } from './dispatchClient';
import { debug } from '../lib/debug';
import { mapVehicle } from './dispatchMappers';
import type { Vehicle } from '../types';

export const updateVehicle = async (vehicleData: any, userId?: string | number): Promise<Vehicle | null> => {
  const { id } = vehicleData;
  if (!id) {
    throw new Error('Vehicle ID is required for update');
  }

  // API仕様書 v1.2.0に基づき、更新可能なフィールドのみを抽出
  const allowedFields = [
    'status',
    'location_status',  // v1.1.0で追加
    'memo',
    'cleaning',
    'car_wash',
    'check1',
    'check2',
    'tire_groove',
    'tire_pressure',
    'active_from',
    'active_to',
    'is_active',        // v1.2.0で追加: 有効フラグ
    'reservation_box_priority',
    'check_situations', // v1.3.0で追加: 動的チェック項目
    'out_of_use',       // v1.4.0で追加: 利用外フラグ
    'json_data',        // v1.5.0で追加: カスタムフィールド
    'detail',           // v2.0.0で追加: 詳細情報オブジェクト（affiliation/owner/user/tire/oil/wax/...）
  ];

  const payload: Record<string, any> = {
    id: Number(id),
  };

  allowedFields.forEach(field => {
    if (vehicleData[field] !== undefined) {
      payload[field] = vehicleData[field];
    }
  });

  // priorityフィールドをreservation_box_priorityに変換 (後方互換性)
  if (vehicleData.priority !== undefined && payload.reservation_box_priority === undefined) {
    payload.reservation_box_priority = vehicleData.priority;
  }

  // statusは数値型であることを保証
  if (payload.status !== undefined) {
    payload.status = Number(payload.status);
  }

  // location_statusはnullまたは数値型
  if (payload.location_status !== undefined && payload.location_status !== null) {
    payload.location_status = Number(payload.location_status);
  }

  // out_of_useはboolean型であることを保証
  if (payload.out_of_use !== undefined) {
    payload.out_of_use = Boolean(payload.out_of_use);
  }

  // json_dataがオブジェクトであることを保証（文字列の場合はパース）
  if (payload.json_data !== undefined && typeof payload.json_data === 'string' && payload.json_data.trim()) {
    try {
      payload.json_data = JSON.parse(payload.json_data);
    } catch (e) {
      console.warn('vehicleService', 'vehicle json_data is not valid JSON string', e);
    }
  }

  // detail がオブジェクト（または null）であることを保証。それ以外はサーバ側で 422 になるため事前に削除。
  if (payload.detail !== undefined && payload.detail !== null && typeof payload.detail !== 'object') {
    console.warn('vehicleService', 'vehicle detail must be an object or null; dropping field', { type: typeof payload.detail });
    delete payload.detail;
  }

  debug.log('vehicleService', 'updateVehicle payload:', payload);

  const response = await apiFetchJson('dispatch/vehicles/update', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  debug.log('vehicleService', 'updateVehicle response:', response);

  const mapped = mapVehicle(response);
  return mapped;
};
